import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import semver from 'semver';
import { useMemo } from 'react';

export const v3Version = '3.0.0';

export const useCanViewV2Button = () => {
  const canAccessLowerVersion = useSelector((state) => {
    const lowestAllowedVersion = Global.selectSellerSellerSetting(state, {
      settingName: 'ShipStationUI.MinimumSemVersion',
    });
    return semver.valid(lowestAllowedVersion) ? semver.lt(lowestAllowedVersion, v3Version) : true;
  });

  const isV3NativeSeller = useSelector((state) => {
    const earlyAccessEnabled =
      Global.selectSellerSellerSetting(state, {
        settingName: 'EarlyAccessEnabled',
      }) === 'true';
    const isNativeV3Seller =
      Global.selectSellerSellerSetting(state, {
        settingName: 'IsNativeV3Seller',
      }) === 'true';
    return earlyAccessEnabled && isNativeV3Seller;
  });

  const canViewButton = useMemo(() => {
    // native V3 users cannot go to V2
    if (isV3NativeSeller) {
      return false;
    }

    // these users can go back and forth
    if (canAccessLowerVersion) {
      return true;
    }

    // users at this point have been migrated by us
    return false;
  }, [isV3NativeSeller, canAccessLowerVersion]);

  return canViewButton;
};
